import React from 'react';
import Modal from 'shared/components/misc/modal.jsx';
import ModalActions from 'flux/actions/ModalActions';
import RouteActions from 'flux/actions/RouteActions';
import UIRegions from 'shared/constants/UIRegions';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { Row, Col, Button, ButtonToolbar } from 'bootstrap';

/**
 * Viewing Deleted Event Error Modal
 *
 */
export default React.createClass({
  mixins: [],

  displayName: 'DeletedEventErrorModal',

  render() {
    let titleNode = (
      <span>
        <Icon name="bell-o" /> Unable To Load Event
      </span>
    );

    return (
      <Modal
        className="modal-generic-wrapper modal-deleted-event-wrapper"
        headerClassName="modal-generic-header alert-modal-title"
        closeButton={false}
        name={UIRegions.ViewingDeletedEventError}
        overrideHide={true}
        title={titleNode}
      >
        <Row className="deleted-event-error-modal">
          <Col lg={24}>
            <p>Unable to load event data. This event is no longer active.</p>
            <ButtonToolbar className="pull-right">
              <Button
                className="deleted-event-error-modal-btn"
                onClick={this._handleClick}
              >
                Go Home
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>
      </Modal>
    );
  },

  _handleClick() {
    RouteActions.goToUserDash();
    ModalActions.hide(UIRegions.ViewingDeletedEventError);
  },
});
